import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { useTranslation } from 'react-i18next';

//styles
import { Input, CheckboxWrapper, CheckBox } from './Checkbox.styled';
import { FormGroup } from 'components/styled/Form.styled';

const departurePointNames = ['Split', 'Rijeka', 'Dubrovnik'];
const CheckboxGroup = ({ setFieldValue, values }) => {
  const { t } = useTranslation();
  const selectAll = (departurePoint, value) => {
    departurePointNames.forEach(point => setFieldValue(`${departurePoint}.${point}`, !value));
  };

  return (
    <FormGroup>
      <CheckboxWrapper selectAllSpacing="1rem">
        <Input
          type="checkbox"
          onClick={() => selectAll('departurePoint', values['allPoints'])}
          name="allPoints"
        />
        <CheckBox />
        {t('Apply to all departure points')}
      </CheckboxWrapper>
      {map(departurePointNames, point => (
        <CheckboxWrapper name="departurePoint" key={point}>
          <Input
            onClick={() => setFieldValue('allPoints', false)}
            type="checkbox"
            name={`departurePoint.${point}`}
          />
          <CheckBox />
          {t('Apply to departure point')} {point}
        </CheckboxWrapper>
      ))}
    </FormGroup>
  );
};

export default CheckboxGroup;

CheckboxGroup.propTypes = {
  values: PropTypes.string,
  setFieldValue: PropTypes.func,
};
